<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">
                        {{ this.isEdit ? `${this.parentObject.pageTitle} - ${this.parentObject.pageTitleValue}` : this.parentObject.pageTitle }}
                    </h2>
                </v-row>
                    <v-row>
                      <v-col cols="4" class="pb-n5">
                       <v-text-field
                                outlined
                                :label="$t('appraisalexerciserecords.appraisalexerciseCode')"
                                type="text"
                                ref="kpiexercode"
                                :rules="[rules.required]"
                                v-model="formData.reviewcode"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>

                      <v-col cols="4" class="pb-n5">
                        <v-autocomplete
                            outlined
                            :label="this.$t('columns.type')"
                            type="text"
                            ref="type"
                            :rules="[rules.required]"
                            v-model="formData.formtype"
                            :items="typeList"
                            @change="updateValue"
                            dense
                        ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="8" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="$t('appraisalexerciserecords.appraisalexercisedescription')"
                                type="text"
                                ref="kpiexerdesc"
                                :rules="[rules.required]"
                                v-model="formData.description"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmreviewexercise.assessmenttype')"
                                type="text"
                                ref="assessmentid"
                                :rules="[rules.required]"
                                v-model="formData.assessmentid"
                                dense
                                :items="assessmentList"
                                @input="updateValue"
                                @change="changeAssessmentHandler(formData.assessmentid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.assessmentcode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-dialog v-model="assessmentDialog" max-width="500px" persistent>
                                <template v-slot:activator="{ on }">
                                    <v-btn dense v-on="on">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <app-genericform 
                                        v-bind:parentData = "{
                                            tabItems: assessmentItems,
                                            formTitle: `Assessment Type`,
                                            formId: 'assessment'
                                        }"
                                        v-on:input="itemData = $event"
                                        v-on:saveAssessment="saveAssessmentHandler"
                                        v-on:deleteAssessment="deleteAssessmentHandler($event)"
                                    />

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="warning"
                                            text
                                            @click="assessmentDialog = false"
                                        >
                                        {{$t('button.close')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.startdate')"
                                type="date"
                                ref="startdate"
                                :rules="[rules.required]"
                                v-model="formData.startdate"
                                @input="updateValue"
                                @change="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.enddate')"
                                type="date"
                                ref="enddate"
                                :rules="[rules.required]"
                                v-model="formData.enddate"
                                @input="updateValue"
                                @change="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('Setuprankmapset.rankmapset')"
                                type="text"
                                ref="pmrankmapsetid"
                                :rules="[rules.required]"
                                v-model="formData.pmrankmapsetid"
                                dense
                                :items="rankMapSetList"
                                @input="updateValue"
                                @change="changeRankMapSet(formData.pmrankmapsetid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.pmrankmapsetcode"
                                readonly
                                dense
                                @input="updateValue"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="8" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="$t('columns.remark')"
                                type="text"
                                ref="remarks"
                                v-model="formData.remarks"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmreviewexercise.kpisettingexercise')"
                                type="text"
                                ref="pmkpiexerciseid"
                                :rules="[rules.required]"
                                v-model="formData.pmkpiexerciseid"
                                dense
                                :items="kpiSettingExerciseList"
                                @input="updateValue"
                                @change="changeKPISetting(formData.pmkpiexerciseid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.pmkpiexercisecode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <!-- <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmreviewexercise.reviewerrole')"
                                type="text"
                                ref="roleid"
                                :rules="[rules.required]"
                                v-model="formData.roleid"
                                dense
                                :items="roleList"
                                @input="updateValue"
                                @change="changeRole(formData.roleid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.rolecode"
                                @input="updateValue"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col> -->
                    </v-row>

                    <v-row>
                        <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.status')"
                                type="text"
                                :items="statusList"
                                hide-selected
                                v-model="formData.statusid"
                                @input="updateValue"
                                dense
                            ></v-autocomplete>
                        </v-col>
                        <!-- <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                type="text"
                                :items="methodList"
                                hide-selected
                                v-model="formData.method"
                                @input="updateValue"
                                dense
                            ></v-autocomplete>
                        </v-col> -->
                        <v-col cols="4" class="pb-n4 mt-n8">
                            <v-checkbox
                                outlined
                                ref="staffFirst"
                                v-model="formData.staffFirst"
                                :label="'Initially Open to Staff'"
                                @change="updateValue"
                                dense
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row v-if="isEdit">
                        <v-col cols="6" sm="6" class="blue--text pb-n4 mt-n8">
                            {{$t('appraisalexerciserecords.reviewstatistics')}}
                        </v-col>
                    </v-row>
                    <v-row v-if="isEdit">
                      <v-col cols="2" class="pb-n4 mt-n4">
                            <v-text-field
                                outlined
                                :label="$t('appraisalexerciserecords.initiated')"
                                type="number"
                                ref="initiated"
                                :rules="[rules.required]"
                                v-model="formData.initiated"
                                @input="updateValue"
                                dense
                                background-color="#ffeab2"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="pb-n4 mt-n4">
                            <v-text-field 
                                outlined
                                :label="$t('appraisalexerciserecords.ongoing')"
                                type="number"
                                ref="ongoing"
                                :rules="[rules.required]"
                                v-model="formData.ongoing"
                                @input="updateValue"
                                dense
                                background-color="#ffeab2"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="pb-n4 mt-n4">
                            <v-text-field
                                outlined
                                :label="$t('appraisalexerciserecords.completed')"
                                type="number"
                                ref="completed"
                                :rules="[rules.required]"
                                v-model="formData.completed"
                                @input="updateValue"
                                dense
                                background-color="#ffeab2"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1" class="pb-n4 ml-2 mt-n4">
                            <v-btn color="primary" class="white--text mb-3" @click="generateRecords">
                                  {{$t('button.generaterecords')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                 
                    <app-formbuttons
                        v-on:SavePressed="saveHandler"
                        v-on:CancelPressed="cancelHandler" 
                    />

                    <v-row class="pb-n4 pl-2" v-if="isEdit">
                        <app-table
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                pmreviewexerciseid: this.parentObject.data.id,
                                detailItem: this.parentObject.reviewExerciseFormList,
                            }"
                            v-on:reload="reloadKpiCommonListHandler"
                        />
                    </v-row>
                
            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';
import GenericForm from '../../generic/GridForm';


export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-genericform': GenericForm,
        'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                id: this.parentObject.data.id,
                reviewcode: this.parentObject.data.reviewcode,
                description: this.parentObject.data.description,
                assessmentid: this.parentObject.data.assessmentid,
                assessmentcode: this.parentObject.data.assessmentcode,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                formtype: this.parentObject.data.formtype,
                pmrankmapsetid: this.parentObject.data.pmrankmapsetid,
                pmrankmapsetcode: this.parentObject.data.pmrankmapsetcode,
                remarks: this.parentObject.data.remarks,
                pmkpiexerciseid: this.parentObject.data.pmkpiexerciseid,
                pmkpiexercisecode: this.parentObject.data.pmkpiexercisecode,
                statusid: this.parentObject.data.statusid,
                staffFirst: this.parentObject.data.staffFirst,
                initiated: this.parentObject.data.initiated,
                ongoing: this.parentObject.data.ongoing,
                completed: this.parentObject.data.completed,
                stamp: this.parentObject.data.stamp,
                userid: this.$store.getters.userId,
            },

            formDataParameter: {
                servicerecasatdate: null,
                hiredate: null,
                cessationdate: null,
                confirmdate: null,
                isOverwrite: false,
            },

            parameters: {
                companyid: null,
                compnyname: null,
                branchid: null,
                brchname: null,
                departmentid: null,
                deptname: null,
                divisionid: null,
                divnname: null,
                sectionid: null,
                sectioname: null,
                unitid: null,
                unitname: null,
                gradeid: null,
                grddesc: null,
                employmenttypeid: null,
                emptypecatdesc: null,
                staffid: null,
                staffcode: null,
            },

            assessmentData: {
                assessmentname: null,
                assessmentcode: null,
                pmreviewexerciseid: null,
                stamp: this.parentObject.data.stamp,
                userid: this.$store.getters.userId,
            },
            assessmentDialog: false,
            assessments: [],
            assessmentList: [],
            assessmentItems: [],

            typeList: [
                { text: this.$t('Setuprankingset.rank'), value: 'R' },
                { text: this.$t('pmreviewexercise.grid'), value: 'G' }
            ],

            // methodList: [
            //     { text: this.$t('pmreviewexercise.method1'), value: 1 },
            //     // { text: this.$t('pmreviewexercise.method2'), value: 2 }
            // ],

            rankMapSet: [],
            rankMapSetList: [],
            kpiSettingExercise: [],
            kpiSettingExerciseList: [],
            status: [],
            statusList: [],
      
            errMsg: '',
            isErr: false,
            isEdit : this.parentObject.isEdit,
            search: this.parentObject.searchnew,

            tabHeader: [
                { value: 'action', width: '100px', sortable: false},
                { text: this.$t('pmreviewexercise.appraisalgroup'), value: 'valvaluecode', width: '200px', sortable: true},
                { text: this.$t('columns.templates'), value: 'pmreviewformcode', width: '200px', sortable: true},
            ],

        }
    },

    methods: {
        getAssessmentListHandler() {
            let vm = this;

            this.$store.dispatch('get', {url: '/assessment/all'})
                .then(res => {
                    vm.assessments = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.assessmentList.push(
                            {
                                text: res.data.rec[i].assessmentname,
                                value: res.data.rec[i].id
                            }
                        )

                        vm.assessmentItems.push(
                            {
                                id: res.data.rec[i].id,
                                code: res.data.rec[i].assessmentcode,
                                desc: res.data.rec[i].assessmentname,
                                stamp: res.data.rec[i].stamp
                            }
                        )
                    }
                    
                    if (vm.formData.assessmentid) {
                        vm.changeAssessmentHandler(vm.formData.assessmentid);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        changeAssessmentHandler(id) {
            let item = this.assessments.find(item => item.id == id);

            this.formData.assessmentcode = item.assessmentcode;
        },

        saveAssessmentHandler() {
            let vm = this;
            if (this.itemData.itemid) {
                this.$store.dispatch('put', {url: '/assessment/' + this.itemData.itemid, payload: {
                    assessmentcode: vm.itemData.itemcode,
                    assessmentname: vm.itemData.itemdesc,
                    stamp: vm.itemData.itemstamp
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // reset all arrays
                        vm.assessments = [];
                        vm.assessmentList = [],
                        vm.assessmentItems = [],

                        this.getAssessmentListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {url: '/assessment/create', payload: {
                    assessmentcode: vm.itemData.itemcode,
                    assessmentname: vm.itemData.itemdesc,
                    userid: this.$store.getters.userId,
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // reset all arrays
                        vm.assessments = [];
                        vm.assessmentList = [],
                        vm.assessmentItems = [];

                        this.getAssessmentListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deleteAssessmentHandler($event) {
            let vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {url: '/assessment/' + $event.id + '/' + this.$store.getters.userId})
                .then(res => {
                    if (res.data.status == 200) {
                        // reset all arrays
                        vm.assessments = [];
                        vm.assessmentList = [],
                        vm.assessmentItems = [],

                        this.getAssessmentListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        loadRankMapSet() {
            const vm = this;
            this.$store.dispatch('get', {url: "/rankmapset/active/all"})
            .then(function (res) {
                vm.rankMapSet = res.data.rec;
        
                for (let i = 0; i < vm.rankMapSet.length; i++) {
                    vm.rankMapSetList.push({
                    text: vm.rankMapSet[i].rankmapset,
                    value: vm.rankMapSet[i].id,
                    });
                }
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        loadKPISettingExercise() {
            const vm = this;
            this.$store.dispatch('get', {url: "/kpiexercise/all/"})
            .then(function (res) {
                vm.kpiSettingExercise = res.data.rec;
        
                for (let i = 0; i < vm.kpiSettingExercise.length; i++) {
                    vm.kpiSettingExerciseList.push({
                    text: vm.kpiSettingExercise[i].kpiexercode,
                    value: vm.kpiSettingExercise[i].id,
                    });
                }
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        loadStatus() {
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewexercise/status/all"})
            .then(function (res) {
                vm.status = res.data.rec;
        
                for (let i = 0; i < vm.status.length; i++) {
                    vm.statusList.push({
                    text: vm.status[i].statusdesc,
                    value: vm.status[i].id,
                    });
                }
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },


        updateValue() {
            this.$emit('input', {
                reviewcode: this.formData.reviewcode,
                description: this.formData.description,
                assessmentid: this.formData.assessmentid,
                assessmentcode: this.formData.assessmentcode,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                formtype: this.formData.formtype,
                pmrankmapsetid: this.formData.pmrankmapsetid,
                pmrankmapsetcode: this.formData.pmrankmapsetcode,
                remarks: this.formData.remarks,
                pmkpiexerciseid: this.formData.pmkpiexerciseid,
                pmkpiexercisecode: this.formData.pmkpiexercisecode,
                statusid: this.formData.statusid,
                staffFirst: this.formData.staffFirst,
            });
        },

        saveHandler() {
            this.$emit('save');
        },

        cancelHandler() {
            this.$router.push({name: 'reviewexerciselist'});
        },

        generateRecords(){
            this.$router.push({name: 'reviewexercisegenerate', params: {formData: this.formData, formDataParameter: this.formDataParameter, parameters: this.parameters}});
        },

        changeRankMapSet(id) {
            let item = this.rankMapSetList.find((item) => item.value === id);
            console.log(item);
            this.formData.pmrankmapsetcode = item.text;
        },

        changeKPISetting(id) {
            let item = this.kpiSettingExerciseList.find((item) => item.value === id);
            this.formData.pmkpiexercisecode = item.text;
        },

    },

    created() {
        this.getAssessmentListHandler();
        this.loadRankMapSet();
        this.loadKPISettingExercise();
        this.loadStatus();
    },
}
</script>

<style scoped>
</style>